import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Slide,
  Stack,
  Box,
  CircularProgress,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
} from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import { forwardRef, useState } from 'react'
import { MRadio } from './@material-extend'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import AddToStockPopup from './AddToStockPopup'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ConfirmationPopup({
  open,
  handleClose,
  message,
  handleClick,
  loading2,
  isComplete,
  setCompleteStatus,
  noServiceNoTask,
  shippingReturn,
  templates,
  isPickup,
  selectTemplate,
  setSelectTemplate,
  selectedInstallationIds,
  handleMarkAsPickup,
  popupOn,
  hideCancel,
  projectCategory,
  projectId,
  projectTasks
}) {
  console.log('projectCategory', projectCategory)
  const { enqueueSnackbar } = useSnackbar()
  const theme = useTheme()
  const navigate = useNavigate()
  const [value, setValue] = useState('1');
  const [showAddToStockPopup, setShowAddToStockPopup] = useState(false);

  // Check if there are eligible products for adding to stock
  const hasEligibleProducts = () => {
    if (!projectTasks || projectTasks.length === 0) return false;
    
    // Filter products that have product_id not null, inhouse != 1, isTrafficCatalog = 0
    const eligibleProducts = projectTasks.filter(task => 
      task.product_id && 
      ((task.inhouse === 1 && task.isTrafficCatalog === 1) || task.inhouse !== 1)
      // task.inhouse !== 1 && 
      // task.isTrafficCatalog === 0
    );
    
    return eligibleProducts.length > 0;
  };
  
    const handleChange = (event) => {
      setValue(event.target.value);
      console.log('ghghfghfghfghfg',event.target.value);
      setCompleteStatus(event.target.value)
    };

    const handleAddToStockConfirm = (stockData) => {
      console.log('Add to stock data:', stockData);
      // Handle the add to stock logic here
      // You can call the parent's handleClick or create a new handler
      if (handleClick) {
        handleClick(stockData);
      }
    };

  return (
    <>
     {!isComplete ? (
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        TransitionComponent={Transition}
        transitionDuration={500}
        sx={{ minWidth: {xs:0 , sm: 600} }}
        open={open}
        onClose={handleClose}
        onBackdropClick={handleClose}
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent sx={{ minWidth: 270, mt: -2 }}>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        {
          isPickup?
        
          <DialogContentText id="alert-dialog-description">
            <Autocomplete
                         fullWidth
                         options={templates || []}
                         filterSelectedOptions
                         value={selectTemplate}
                         onChange={(event, newValue) => {  
                          setSelectTemplate(newValue)
                         }}
                         getOptionLabel={(option) => option.name}
                         renderInput={(params) => (
                           <TextField
                             {...params}
                             label="Select Template"
                             placeholder="Select Template"
                             size="small"
                           />
                         )}
                       />
          </DialogContentText>
          :""
                        }
        </DialogContent>
        {/* <DialogActions sx={{ justifyContent: 'flex-end !important' }}> */}
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          px={3}
          mb={2.5}
          mt={-1}
        >
          <Button
            size="medium"
            onClick={() => {
              handleClose()
              enqueueSnackbar('Operation was cancelled', { variant: 'error' })
            }}
            sx={{
              background: '#BB2525',
              boxShadow: `0 8px 16px 0 ${alpha('#BB2525', 0.24)}`,
              '&:hover': {
                background: '#FF8F8F',
                boxShadow: `0 8px 16px 0 ${alpha('#FF8F8F', 0.24)}`,
              },
            }}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Cancel
            </Typography>
          </Button>
          <Button
            size="medium"
            variant="contained"
            onClick={() => {
              if(isPickup && !selectTemplate){
                return enqueueSnackbar('Select a Template', { variant: 'error' })
              }else if(isPickup && selectTemplate){
                if(popupOn){
                  handleMarkAsPickup(selectTemplate.id,selectedInstallationIds,isPickup)
                }else{
                navigate(`${PATH_DASHBOARD.installation.templateview}/${selectTemplate.id}`,{
                  state: { selectedInstallationIds: selectedInstallationIds,template_id : selectTemplate.i,isPickup:true}
                }, )
                }
              }else{
                handleClick()
              }
            }}
            sx={{ color: theme.palette.primary.main }}
            disabled={loading2}
          >
            {loading2 ? (
            <CircularProgress size={22} sx={{ color: theme.palette.common.white }} />
          ) : (
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Yes
            </Typography>
          )}
          </Button>
        </Stack>
        {/* </DialogActions> */}
      </Dialog>
      ):(
        <Dialog
        aria-describedby="alert-dialog-slide-description"
        TransitionComponent={Transition}
        transitionDuration={500}
        sx={{ minWidth: {xs:0 , sm: 600},padding:'5px' }}
        open={open}
        // onClose={handleClose}
        // onBackdropClick={handleClose}
      >
        {/* <DialogTitle>{projectCategory == 12 ? "Send For Review" :noServiceNoTask == 1 ? 'No Installations - Proceed to Invoicing' : 'Please Choose from the following'}</DialogTitle> */}
        <DialogTitle>{(noServiceNoTask == 1 && projectCategory !== 12) ? 'No Installations - Proceed to Invoicing' : 'Please Choose from the following'}</DialogTitle>
        <DialogContent sx={{ minWidth: 270, mt: 0 }}>
          <DialogContentText id="alert-dialog-description">
            {/* {message} */}
            <FormControl component="fieldset">
              <RadioGroup value={value} onChange={handleChange}>
              
              {/* {(noServiceNoTask == 1 || projectCategory == 12 ) ?
                <FormControlLabel value="1" control={<Radio />} label={projectCategory == 12 ? "Installs" :"Invoice" }/> */}

                {(noServiceNoTask == 1 && projectCategory !== 12) ?
                  <FormControlLabel value="1" control={<Radio />} label="Invoice" />
                : (
                  <>
                    <FormControlLabel value="1" control={<Radio />} label="Installs" />
                    <FormControlLabel value="2" control={<Radio />} label="Pickup" />
                    <FormControlLabel value="3" control={<Radio />} label="Shipping" />
                    {projectCategory == 13 ? <FormControlLabel value="4" control={<Radio />} label="Add to stock" /> : ""}
                  </>
                )}
              </RadioGroup>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions sx={{ justifyContent: 'flex-end !important' }}> */}
        <Stack
          direction={'row'}
          justifyContent={'flex-end'}
          px={3}
          mb={2.5}
          mt={-1}
        >
          {
            hideCancel ? "" :
         
          <Button
            size="medium"
            onClick={() => {
              handleClose()
              enqueueSnackbar('Operation was cancelled', { variant: 'error' })
            }}
            sx={{
              background: '#BB2525',
              boxShadow: `0 8px 16px 0 ${alpha('#BB2525', 0.24)}`,
              '&:hover': {
                background: '#FF8F8F',
                boxShadow: `0 8px 16px 0 ${alpha('#FF8F8F', 0.24)}`,
              },
            }}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
              Cancel
            </Typography>
          </Button>
           }

          <Button
            size="medium"
            variant="contained"
            onClick={() => {
              if (value === '4') {
                // Check if there are eligible products before showing the popup
                if (!hasEligibleProducts()) {
                  enqueueSnackbar("Production catalog doesn't have stock", { variant: 'warning' });
                  return;
                }
                // Show Add to Stock popup
                setShowAddToStockPopup(true);
              } else {
                handleClick()
              }
            }}
            // sx={{ color: theme.palette.primary.main }}
            disabled={loading2}
          >
            <Typography
              sx={{ color: theme.palette.common.white }}
              variant="overline"
            >
            </Typography>
              {loading2 ? <CircularProgress size={24} color="inherit" /> : 'Yes'}
          </Button>
        </Stack>
        {/* </DialogActions> */}
      </Dialog>)}

      {/* Add to Stock Popup */}
      <AddToStockPopup
        open={showAddToStockPopup}
        handleClose={() => setShowAddToStockPopup(false)}
        projectId={projectId}
        onConfirm={handleAddToStockConfirm}
      />
    </>
  )
}
